export default {
  HI: 'Salut {{ name }}!',
  RETURN_HOME: 'Retour à la page d’accueil',
  RETURN_DASHBOARD: 'Aller au tableau de bord',
  MY_PROFILE: 'Mon profil',
  MY_NOTIFICATIONS: 'Mes notifications',
  MY_SETTINGS: `Mes paramètres`,
  CHANGE_LANGUAGE: 'English',
  LOG_OUT: 'Déconnexion',
  SWITCH_TO_OLD_VERSION: "Revenir à l'ancienne version",
  NEXT_SHIFT_IS: 'Voici votre prochain quart',
  SHIFT_JUST_ENDED: `Votre quart vient de finir`,
  SHIFT_STARTED_AT: `Votre quart d'aujourd'hui`,
  NO_UPCOMING_SHIFTS: "Vous n'avez pas de quart de travail à venir",
  EMOJI_MODAL: {
    TITLE: 'Bienvenue au Zoo Merinio!',
    SUMMARY: `Sélectionnez l'animal qui vous représente le mieux.`
  },
  IMPORTANT_INFORMATION_MODAL: {
    TITLE: `Informations importantes`,
    SUMMARY: ``,
    USERNAME: `Nom d'utilisateur`,
    EMPLOYEE_NUMBER: `Numéro d'employé`,
    TWILIO_PHONE: `Numéro du système téléphonique`,
    COMPANY_ID: `Identifiant de compagnie (Début d'url pour app mobile)`,
    HELP_CENTER: `Centre d'aide`
  },
  EMPLOYEE: `Moi`,
  MANAGER: `Gestion`,
  ADMINISTRATION: `Admin`,
  SEE_MY: `Voir les miennes`,
  UNABLE_TO_LOAD_NEXT_SHIFT: `Impossible de charger votre prochain quart`
}
